/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './tooltip.component.css.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '@swimlane/ngx-charts/release/common/tooltip/tooltip.component';
const styles_TooltipContentComponent:any[] = [i0.styles];
export const RenderType_TooltipContentComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_TooltipContentComponent,data:{}});
function View_TooltipContentComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵted((null as any),['\n          ']))],(null as any),
      (null as any));
}
function View_TooltipContentComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),5,'span',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted((null as any),['\n          '])),(_l()(),i1.ɵand(16777216,(null as any),
      (null as any),2,(null as any),View_TooltipContentComponent_2)),i1.ɵdid(540672,
      (null as any),0,i2.NgTemplateOutlet,[i1.ViewContainerRef],{ngTemplateOutlet:[0,
          'ngTemplateOutlet'],ngOutletContext:[1,'ngOutletContext']},(null as any)),
      i1.ɵpod({model:0}),(_l()(),i1.ɵted((null as any),['\n        ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.template;
    const currVal_1:any = _ck(_v,4,0,_co.context);
    _ck(_v,3,0,currVal_0,currVal_1);
  },(null as any));
}
function View_TooltipContentComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),
      [[8,'innerHTML',1]],(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n        ']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.title;
    _ck(_v,0,0,currVal_0);
  });
}
export function View_TooltipContentComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{caretElm:0}),(_l()(),i1.ɵted((null as any),
      ['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),13,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted((null as any),['\n      '])),(_l()(),i1.ɵeld(0,[[1,0],['caretElm',1]],
      (null as any),1,'span',([] as any[]),[[8,'hidden',0],[8,'className',0]],(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n      '])),
      (_l()(),i1.ɵted((null as any),['\n      '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),7,'div',[['class','tooltip-content']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,
          (null as any),View_TooltipContentComponent_1)),i1.ɵdid(16384,(null as any),
          0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_TooltipContentComponent_3)),i1.ɵdid(16384,
          (null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n      '])),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵted((null as any),['\n  ']))],(_ck,_v) => {
    var _co:i3.TooltipContentComponent = _v.component;
    const currVal_2:boolean = !_co.title;
    _ck(_v,10,0,currVal_2);
    const currVal_3:any = _co.title;
    _ck(_v,13,0,currVal_3);
  },(_ck,_v) => {
    var _co:i3.TooltipContentComponent = _v.component;
    const currVal_0:boolean = !_co.showCaret;
    const currVal_1:any = i1.ɵinlineInterpolate(1,'tooltip-caret position-',_co.placement,
        '');
    _ck(_v,4,0,currVal_0,currVal_1);
  });
}
export function View_TooltipContentComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'ngx-tooltip-content',
      ([] as any[]),[[8,'className',0]],[['window','resize']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('window:resize' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1).onWindowResize()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },View_TooltipContentComponent_0,RenderType_TooltipContentComponent)),i1.ɵdid(4243456,
      (null as any),0,i3.TooltipContentComponent,[i1.ElementRef,i1.Renderer],(null as any),
      (null as any))],(null as any),(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).cssClasses;
    _ck(_v,0,0,currVal_0);
  });
}
export const TooltipContentComponentNgFactory:i1.ComponentFactory<i3.TooltipContentComponent> = i1.ɵccf('ngx-tooltip-content',
    i3.TooltipContentComponent,View_TooltipContentComponent_Host_0,{host:'host',showCaret:'showCaret',
        type:'type',placement:'placement',alignment:'alignment',spacing:'spacing',
        cssClass:'cssClass',title:'title'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/~/@swimlane/ngx-charts/release/common/tooltip/tooltip.component.ngfactory.ts